/// <amd-module name="Pipeline/Analytics/DurationMetricsTrendCard/Stores/DurationMetricsTrendCardStore" />

import { ITrendChartData } from "Analytics/Shared/TrendChart/Common/Types";
import { IPipelineReportBaseState, PipelineReportBaseStore } from "Pipeline/Analytics/Common/Stores/PipelineReportBaseStore";
import { DurationMetricsTrendCardActions } from "Pipeline/Analytics/DurationMetricsTrendCard/Actions/DurationMetricsTrendCardActions";
import { IMaxDurationTaskData, IPipelineDurationData } from "Pipeline/Analytics/PipelineDurationCommon/Types";

export interface IDurationMetricsTrendCardState extends IPipelineReportBaseState<ITrendChartData> {
    pipelineDurationData: IPipelineDurationData;
    insightsData?: IMaxDurationTaskData;
}

export class DurationMetricsTrendCardStore extends PipelineReportBaseStore<
    DurationMetricsTrendCardActions,
    IDurationMetricsTrendCardState,
    ITrendChartData
> {
    constructor(public actions: DurationMetricsTrendCardActions) {
        super(actions);
        this.initializeListener();
    }

    public dispose(): void {
        this.actions.updatePipelineDurationDataAction.removeListener(this.onUpdatePipelineDurationData);
        this.actions.updateInsightsDataAction.removeListener(this.onUpdateInsightsData);
        super.dispose();
    }

    protected initializeListener(): void {
        this.actions.updatePipelineDurationDataAction.addListener(this.onUpdatePipelineDurationData);
        this.actions.updateInsightsDataAction.addListener(this.onUpdateInsightsData);
    }

    protected onUpdatePipelineDurationData = (data: IPipelineDurationData) => {
        if (data) {
            this._state.errorText = undefined;
            this._state.pipelineDurationData = data;
            this.emitChanged();
        }
    };

    protected onUpdateInsightsData = (data: IMaxDurationTaskData) => {
        if (data) {
            this._state.errorText = undefined;
            this._state.insightsData = data;
            this.emitChanged();
        }
    };
}
